import request from "../utils/request";
const M4_PREFIX = "api/sns-audit";
const baseUrl = process.env.BASE_URL;
const prefix = `${baseUrl}${M4_PREFIX}`;
export function upload(data) {
  return request({
    url: `${prefix}/sohucs/upload`,
    method: "post",
    data
  });
}

export function save(data) {
  return request({
    url: `${prefix}/complaint/save`,
    method: "post",
    data
  });
}

export function getDetailById(data) {
  return request({
    url: `${prefix}/complaint/viewById`,
    method: "get",
    params: data
  });
}

export function getRecordList(data) {
  return request({
    url: `${prefix}/complaint/listByPassPort`,
    method: "get",
    params: data
  });
}

export function getCaptcha() {
  return request({
    url: `${prefix}/complaint/captcha`,
    method: "get"
  });
}
